import { Link } from "react-router-dom";
import { byPath } from "../data/registry";

const LABEL = { "en-IN": "Keep reading", "hi-IN": "यह भी पढ़ें" };

/** Links from chunk.related, resolved to registry titles. Unknown paths are skipped. */
export default function Related({ paths = [], lang }) {
  const entries = paths.map(byPath).filter(Boolean);
  if (entries.length === 0) return null;
  return (
    <nav className="tpl-section" aria-labelledby="tpl-related">
      <h2 id="tpl-related" className="tpl-section__title">
        {LABEL[lang] ?? LABEL["en-IN"]}
      </h2>
      <ul className="tpl-related">
        {entries.map((e) => (
          <li key={e.path}>
            <Link to={e.path}>{e.type === "static" ? e.h1 : e.title}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
